import { FC } from 'react'
import styles from 'components/features/pfm/VideoLayout/VideoLayout.styl'
import AdjustableImage from 'components/features/pfm/AdjustableImage/AdjustableImage'
import { ImageURLs } from 'interfaces/media'
import Spinner from 'components/features/pfm/Spinner/Spinner'
import cn from 'classnames'

type VideoLayoutProps = {
  poster?: ImageURLs | null
  isLoaded?: boolean
  isLoading?: boolean
  onPlay?: () => void
}

export const VideoLayout: FC<VideoLayoutProps> = (props) => {
  const { poster, isLoaded, isLoading, onPlay, children } = props

  const playButtonClassName = cn(
    styles.playButton,
    {
      [styles.isLoading]: isLoading,
    }
  )

  return (
    <div className={ styles.videoLayout }>
      <AdjustableImage image={ poster }>
        { !isLoaded &&
          <div className={ styles.content }>
            <div className={ playButtonClassName } onClick={ onPlay }>
              { isLoading &&
                <div className={ styles.spinner }>
                  <Spinner size='normal' />
                </div>}
              { !isLoading &&
                <div className={ styles.playIcon } />}
            </div>
          </div>}
        { children && (
          <div className={ styles.content }>
            { children }
          </div>
        )}
      </AdjustableImage>
    </div>
  )
}
